export default `
  .cover-upload-placeholder {
    .background {
      fill: var(--color-base-neutral80);
    }
  }
`;
